import React, {Fragment} from "react";
import {useTheme} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery/useMediaQuery";
import {makeStyles} from "@mui/styles";
import {Box} from "@mui/system";
import businessLogo from "../../../../../images/business.svg";
import RadioButtonLabel from "../../../../common/RadioButtonLabel";
import styles from "../../styles/Providers.module.css"

export default function ChannelRow({id, channelName, customUrl, thumbnailUrl, input}) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const classes = useStyles();

    const addDefaultSrc = (ev) => {
        ev.target.src = businessLogo
    };

    return(
        <Fragment>
            <Box className={classes.container} key={id} {...input}>
                <Box className={classes.channelInfoContainer}>
                    <Box className={classes.imageContainer}>
                        <img onError={addDefaultSrc} src={thumbnailUrl} className={styles.thumbnail} alt="channel thumbnail"/>
                    </Box>
                    <Box className={isMobile ? classes.channelNameMobile : classes.channelName}>
                        <span>{customUrl}</span>
                    </Box>
                </Box>
                <Box className={classes.checkboxContainer}>
                    <RadioButtonLabel value={id} />
                </Box>
            </Box>
        </Fragment>
    )
}

const useStyles = makeStyles({
    channelName: {
        color: '#0F0A05',
        fontFamily: 'FustatRegular',
        fontSize: '18px',
        lineHeight: '120%',
        width: 'calc(100% - 47px)',
        padding: '0 15px',
    },
    channelNameMobile: {
        color: '#0F0A05',
        fontFamily: 'FustatRegular',
        fontSize: '16px',
        lineHeight: '120%',
        width: 'calc(100% - 47px)',
        padding: '0 10px'
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        margin: '5px 0 20px 0'
    },
    channelInfoContainer: {
        display: 'flex',
        alignItems: 'center',
        marginRight: '20px',
        width: '100%'
    },
    imageContainer: {
        width: '47px',
        height: '47px',
        maxWidth: '47px',
        maxHeight: '47px',
        border: '1px solid #fafafa'
    },
    checkboxContainer: {
        width: 'fit-content',
        height: 'fit-content'
    },
});